import { Box, Button, Grid, Typography } from "@material-ui/core"
import { DialogSaurus } from "../dialog-saurus/dialog-saurus"
import { ConfirmarIcon } from "../../icons/confirmar-icon"
import { DesfazerIcon } from "../../icons"
import { useStyles } from "../dialog-processo-setor/dialog-processo-setor-styles"
import { FormConfigLayout } from "../../form/master/config-gerais/form-config-gerais"
import { useCallback, useEffect, useRef } from "react"
import { DefaultFormRefs } from "../../form/utils"
import { useDialog } from "../../../../services/app/providers/dialog-provider"
import { ConfigGeraisModel, useConfigGeraisStore } from "../../../../services/app/stores/config-gerais"
import { useToastSaurus } from "../../../../services/app"
import { useThemeQueries } from "../../../theme"

interface Props {
    openned: boolean
}

export const DialogConfigGerais = ({ openned }: Props) => {
    const { fecharConfigGerais } = useDialog()
    const classes = useStyles();
    const configuracoes = useConfigGeraisStore(state => state.config)
    const setConfig = useConfigGeraisStore(state => state.setConfig)
    const { showToast } = useToastSaurus()
    const { isMobile } = useThemeQueries()

    const formConfigRef = useRef<DefaultFormRefs<ConfigGeraisModel>>(null)

    const submitFormConfigLayout = useCallback((model: ConfigGeraisModel) => {
        setConfig(model)
        showToast('success', 'Configurações salvas com sucesso!')
        fecharConfigGerais()
    }, [fecharConfigGerais, setConfig, showToast])

    useEffect(() => {
        if (openned) {
            setTimeout(() => {
                formConfigRef.current?.fillForm(configuracoes)
            }, 100)
        }
    }, [configuracoes, openned])

    return (
        <DialogSaurus
            fullScreen={isMobile}
            aberto={openned} tamanho="md" bottomArea={
                <Box p={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button
                                startIcon={<ConfirmarIcon tipo="BUTTON_PRIMARY" />}
                                variant="contained"
                                color="primary"
                                size="large"
                                fullWidth
                                onClick={() => {
                                    formConfigRef.current?.submitForm()
                                }}
                            >
                                <Typography
                                    className={classes.titleContinuar}>Continuar</Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant="outlined"
                                color="primary"
                                startIcon={<DesfazerIcon tipo="BUTTON" />}
                                onClick={fecharConfigGerais}
                                size="large"
                                fullWidth
                            >
                                <Typography className={classes.titleVoltar}>Voltar</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            }>
            <Grid container spacing={2} justifyContent="center" className={classes.dialogContainer}>
                <Grid item xs={12} className={classes.titleStyle} >
                    <Typography className={classes.titlePrincipal}>Configurações Gerais</Typography>
                    <Typography variant="body2" color="textSecondary">
                        Estas configurações são locais e válidas apenas neste dispositivo.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <FormConfigLayout
                        ref={formConfigRef}
                        onSubmit={submitFormConfigLayout}
                        showLoading={false}
                        loading={false} />
                </Grid>
            </Grid>
        </DialogSaurus>
    )
}